// extracted by mini-css-extract-plugin
export var container = "layout-module--container--dmN8z";
export var header = "layout-module--header--I6umx";
export var heading = "layout-module--heading--egftK";
export var navLinks = "layout-module--nav-links--dMaQu";
export var navLinkItem = "layout-module--nav-link-item--b8aEZ";
export var navLinkText = "layout-module--nav-link-text--BYPBK";